import styled from "styled-components";

export const Wrapper = styled.div`
  height: 55px;
  align-items: center;
  display: flex;
  justify-content: flex-end;
  border: 0.5px solid whitesmoke;
  border-radius: 8px;
  box-shadow: var(
    --box-shadow,
    0 -2px 8px 0 rgba(128, 134, 139, 0.09),
    0 4px 8px 0 rgba(128, 134, 139, 0.06),
    0 1px 2px 0 rgba(60, 64, 67, 0.3),
    0 2px 6px 0 rgba(60, 64, 67, 0.15)
  );

  margin-bottom: 10px;

  @media (max-width: 820px) {
    height: 55px;
    margin-bottom: 0px;
    border-radius: 0px;
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.13);
    border: 0px solid lightgrey;
  }
`;

export const PlayerBtnWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  margin: 0 10px;
`;

export const PlayerBtn = styled.img`
  letter-spacing: normal;
  font-size: 17.5px;
  font-stretch: normal;
  font-style: normal;
  padding: 0;
  color: white;
  width: 35px;
  height: 35px;
  justify-content: center;
  align-items: center;

  @media (max-width: 820px) {
    width: 35px;
    height: 35px;
  }
`;

export const PlayerBtnText = styled.span`
  color: black;
  font-size: 12px;
  font-weight: 500;
  margin-top: 3px;
`;
